import { isMobileFunc } from '@/helper/functions';
import clsx from 'clsx';

function Modal({ title = null, onOpenChange, width = '520', height = '520', className, children }) {
  const closeModal = (e) => {
    if (e.target.id == 'modal') {
      onOpenChange(false);
    }
  };
  return (
    <div
      id="modal"
      onClick={closeModal}
      className="z-50 bg-[#070707cc] backdrop-opacity-disabled w-screen h-[100dvh] fixed inset-0 flex items-center justify-center max-sm:items-end"
    >
      <div
        style={{ width: `${width}px`, maxHeight: `${height}px` }}
        className={clsx(
          className,
          isMobileFunc() ? 'animate-enter-top' : `animate-enter`,
          'flex flex-col items-center overflow-hidden bg-white rounded-2xl max-sm:rounded-3xl max-sm:rounded-b-none max-sm:w-screen relative',
        )}
      >
        {title && (
          <section className="flex items-center justify-center w-full h-10">
            <p className="text-2xl max-sm:text-lg font-extrabold text-text-hard">{title}</p>
            <span
              id="modal-btn"
              onClick={() => onOpenChange(false)}
              className="absolute left-7 top-7 w-8 h-8 transition-all flex items-center justify-center rounded-xl cursor-pointer hover:bg-light-grey/30"
            >
              <svg className="w-6 h-6">
                <use href="#close"></use>
              </svg>
            </span>
          </section>
        )}
        {children}
      </div>
    </div>
  );
}

export default Modal;
